import {Injectable, signal} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PreviewFilesStateService {
  private _previewFilesState = signal<Record<number, string>>({});
  public previewFilesState = this._previewFilesState.asReadonly();

  public updatePreviewFilesState(id: number, url: string): void {
    this._previewFilesState.update(current => ({
      ...current,
      [id]: url
    }));
  }

  public removeFileById(id: number): void {
    this._previewFilesState.update(current => {
      const url = current[id];
      if (url?.startsWith('blob:')) {
        URL.revokeObjectURL(url);
      }

      const newState = { ...current };
      delete newState[id];
      return newState;
    });
  }

  public resetPreviewFilesState(): void {
    const currentState = this._previewFilesState();
    Object.values(currentState).forEach(url => {
      if (url.startsWith('blob:')) {
        URL.revokeObjectURL(url);
      }
    });

    this._previewFilesState.set({});
  }

  public getFileUrl(id: number): string {
    return this._previewFilesState()?.[id];
  }
}
